import axios from "axios";
import {auth} from "@/data/auth";

export const http = axios.create()

http.interceptors.request.use(async (config) => {
    if (config.skipAuth) {
        return config
    }
    const token = await auth.getAccessToken()
    if (token) {
        config.headers.Authorization = `Bearer ${token}`
    }
    return config
})

http.interceptors.response.use(null, async (error) => {
    const config = error.config
    if (error.response?.status !== 401 || !config || config.skipAuth || config._retry) {
        throw error
    }
    config._retry = true

    let token
    try {
        token = await auth.refresh()
    } catch (refreshError) {
        throw error
    }
    if (!token) {
        throw error
    }

    config.headers.Authorization = `Bearer ${token}`
    return http(config)
})
